import { render, staticRenderFns } from "./PalletEditor.vue?vue&type=template&id=09d4921e&"
import script from "./PalletEditor.vue?vue&type=script&lang=js&"
export * from "./PalletEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports